/**
 * docsScreenStyles.js — StyleSheet for DocsScreen.
 * Extracted verbatim from screens/DocsScreen.jsx (god-file decomposition).
 */

import { Platform, StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: '#0f0f17',
  },
  // Header
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingTop: Platform.OS === 'web' ? 16 : 50,
    paddingBottom: 14,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.07)',
    gap: 12,
  },
  backBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 8,
    backgroundColor: 'rgba(255,255,255,0.07)',
  },
  backBtnText: { color: 'rgba(255,255,255,0.7)', fontSize: 13, fontWeight: '600' },
  headerTitle: { color: '#fff', fontSize: 18, fontWeight: '800' },
  headerSub: { color: 'rgba(255,255,255,0.4)', fontSize: 12, marginTop: 1 },
  searchShortcut: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingVertical: 7,
    paddingHorizontal: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(167,139,250,0.35)',
    backgroundColor: 'rgba(167,139,250,0.1)',
  },
  searchShortcutText: { color: '#a78bfa', fontSize: 13, fontWeight: '600' },
  // Tabs
  tabBar: {
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.07)',
    maxHeight: 46,
  },
  tabBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderBottomWidth: 2,
    borderBottomColor: 'transparent',
  },
  tabBtnActive: { borderBottomColor: '#a78bfa' },
  tabBtnText: { color: 'rgba(255,255,255,0.45)', fontSize: 13, fontWeight: '600' },
  tabBtnTextActive: { color: '#a78bfa' },
  // Tab content
  tabContent: { flex: 1, padding: 16 },
  // Sections
  section: { marginBottom: 24 },
  sectionTitle: { color: '#fff', fontSize: 16, fontWeight: '800', marginBottom: 6 },
  sectionSubtitle: { color: 'rgba(255,255,255,0.5)', fontSize: 13, lineHeight: 20, marginBottom: 12 },
  // Table card
  tableCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.08)',
    backgroundColor: 'rgba(255,255,255,0.03)',
    overflow: 'hidden',
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 12,
    gap: 8,
    flexWrap: 'wrap',
  },
  tableRowBorder: { borderBottomWidth: 1, borderBottomColor: 'rgba(255,255,255,0.06)' },
  tablePattern: { color: '#fff', fontSize: 12, fontWeight: '600', fontFamily: Platform.OS === 'web' ? 'monospace' : undefined },
  tableDesc: { color: 'rgba(255,255,255,0.45)', fontSize: 11, marginTop: 2 },
  tryBtn: { flexDirection: 'row', alignItems: 'center', backgroundColor: 'rgba(167,139,250,0.1)', borderRadius: 6, paddingVertical: 4, paddingHorizontal: 8 },
  tryBtnText: { color: '#a78bfa', fontSize: 11, fontFamily: Platform.OS === 'web' ? 'monospace' : undefined },
  // Query type cards
  queryTypeCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.08)',
    borderLeftWidth: 3,
    backgroundColor: 'rgba(255,255,255,0.03)',
    padding: 14,
    marginBottom: 10,
  },
  queryTypeHeader: { flexDirection: 'row', alignItems: 'flex-start', gap: 10 },
  queryTypeIconWrap: { width: 34, height: 34, borderRadius: 8, justifyContent: 'center', alignItems: 'center', marginTop: 1 },
  queryTypeLabel: { fontSize: 14, fontWeight: '800', marginBottom: 3 },
  queryTypeDesc: { color: 'rgba(255,255,255,0.55)', fontSize: 12, lineHeight: 18, flex: 1 },
  expandLabel: { color: 'rgba(255,255,255,0.35)', fontSize: 10, fontWeight: '700', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 },
  paramBadge: { paddingVertical: 3, paddingHorizontal: 8, borderRadius: 6, backgroundColor: 'rgba(255,255,255,0.08)', borderWidth: 1, borderColor: 'rgba(255,255,255,0.1)' },
  paramBadgeText: { color: 'rgba(255,255,255,0.6)', fontSize: 11 },
  supportText: { color: 'rgba(255,255,255,0.6)', fontSize: 12 },
  exampleRow: { flexDirection: 'row', alignItems: 'center', gap: 10, padding: 10, borderRadius: 8, backgroundColor: 'rgba(255,255,255,0.04)', borderWidth: 1, borderColor: 'rgba(255,255,255,0.07)' },
  exampleLabel: { color: 'rgba(255,255,255,0.4)', fontSize: 11 },
  exampleQuery: { fontSize: 13, fontWeight: '600', marginTop: 2 },
  runBtn: { flexDirection: 'row', alignItems: 'center', paddingVertical: 5, paddingHorizontal: 10, borderRadius: 7, borderWidth: 1 },
  runBtnText: { fontSize: 12, fontWeight: '700' },
  // Builder
  previewBar: {
    margin: 16,
    padding: 16,
    borderRadius: 14,
    borderWidth: 1.5,
    borderColor: 'rgba(167,139,250,0.4)',
    backgroundColor: 'rgba(167,139,250,0.07)',
    gap: 6,
  },
  previewLabel: { color: 'rgba(255,255,255,0.35)', fontSize: 10, fontWeight: '700', textTransform: 'uppercase', letterSpacing: 1 },
  previewQuery: { color: '#fff', fontSize: 20, fontWeight: '800', lineHeight: 26 },
  executeBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    backgroundColor: '#a78bfa',
    paddingVertical: 9,
    paddingHorizontal: 20,
    borderRadius: 10,
    marginTop: 4,
  },
  executeBtnText: { color: '#0f0f17', fontWeight: '800', fontSize: 14 },
  builderStep: {
    marginHorizontal: 16,
    marginBottom: 20,
    paddingBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.06)',
  },
  stepHeader: { flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 10 },
  stepNum: { width: 22, height: 22, borderRadius: 11, backgroundColor: 'rgba(255,255,255,0.12)', justifyContent: 'center', alignItems: 'center' },
  stepNumDone: { backgroundColor: '#a78bfa' },
  stepNumText: { color: 'rgba(255,255,255,0.5)', fontSize: 11, fontWeight: '700' },
  stepLabel: { color: '#fff', fontSize: 14, fontWeight: '700' },
  stepHint: { color: 'rgba(255,255,255,0.35)', fontSize: 12, marginTop: 6, lineHeight: 18 },
  pillRow: { flexDirection: 'row', flexWrap: 'wrap', gap: 6 },
  pill: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.15)',
    backgroundColor: 'transparent',
  },
  pillText: { color: 'rgba(255,255,255,0.5)', fontSize: 13, fontWeight: '600' },
  builderInput: {
    backgroundColor: 'rgba(255,255,255,0.06)',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.12)',
    borderRadius: 10,
    paddingHorizontal: 14,
    paddingVertical: 10,
    color: '#fff',
    fontSize: 14,
  },
  playerList: {
    marginTop: 8,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.08)',
    overflow: 'hidden',
    maxHeight: 240,
  },
  playerRow: {
    paddingVertical: 9,
    paddingHorizontal: 12,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.05)',
  },
  playerRowActive: { backgroundColor: 'rgba(232,121,249,0.08)' },
  playerName: { color: 'rgba(255,255,255,0.75)', fontSize: 13 },
  resetBtn: { flexDirection: 'row', alignItems: 'center', gap: 6, alignSelf: 'center', marginTop: 10, padding: 8 },
  resetBtnText: { color: 'rgba(255,255,255,0.35)', fontSize: 13 },
  // Sport tabs
  sportTabBar: {
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.06)',
    maxHeight: 44,
    paddingVertical: 6,
  },
  sportTab: {
    paddingVertical: 5,
    paddingHorizontal: 12,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.1)',
  },
  sportTabActive: { borderColor: '#a78bfa', backgroundColor: 'rgba(167,139,250,0.15)' },
  sportTabText: { color: 'rgba(255,255,255,0.45)', fontSize: 12, fontWeight: '600' },
  sportTabTextActive: { color: '#a78bfa' },
  // Search input
  searchInput: {
    backgroundColor: 'rgba(255,255,255,0.06)',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.1)',
    borderRadius: 10,
    paddingHorizontal: 14,
    paddingVertical: 9,
    color: '#fff',
    fontSize: 13,
  },
  // Markets
  marketSection: { color: 'rgba(255,255,255,0.4)', fontSize: 10, fontWeight: '700', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8, marginTop: 4 },
  marketGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 6 },
  marketBadge: {
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: 'rgba(96,165,250,0.3)',
    backgroundColor: 'rgba(96,165,250,0.06)',
  },
  marketBadgeText: { color: '#60a5fa', fontSize: 12 },
  showMoreBtn: { marginTop: 14, alignSelf: 'center', paddingVertical: 8, paddingHorizontal: 20, borderRadius: 8, borderWidth: 1, borderColor: 'rgba(255,255,255,0.15)' },
  showMoreText: { color: 'rgba(255,255,255,0.5)', fontSize: 13 },
  loadMoreBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    marginTop: 12,
    paddingVertical: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(167,139,250,0.3)',
    backgroundColor: 'rgba(167,139,250,0.06)',
  },
  loadMoreText: { color: '#a78bfa', fontSize: 13, fontWeight: '600' },
  // Team accordion
  teamAccordion: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(96,165,250,0.15)',
    backgroundColor: 'rgba(96,165,250,0.04)',
    marginBottom: 8,
    overflow: 'hidden',
  },
  teamAccordionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 12,
  },
  teamAccordionLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flex: 1,
  },
  teamAccordionName: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '700',
    flex: 1,
  },
  injuredBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 8,
    backgroundColor: 'rgba(239,68,68,0.12)',
    borderWidth: 1,
    borderColor: 'rgba(239,68,68,0.3)',
  },
  injuredBadgeText: { color: '#f87171', fontSize: 10, fontWeight: '700' },
  teamRosterCount: { color: 'rgba(255,255,255,0.3)', fontSize: 11 },
  teamMLBtn: {
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: 'rgba(96,165,250,0.35)',
    backgroundColor: 'rgba(96,165,250,0.08)',
  },
  teamMLBtnText: { color: '#60a5fa', fontSize: 11, fontWeight: '700' },
  rosterContainer: {
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.06)',
    paddingTop: 4,
    paddingBottom: 4,
  },
  // Player row inside roster
  playerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 9,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.04)',
  },
  playerRowLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flex: 1,
  },
  playerRowPos: {
    width: 28,
    color: 'rgba(255,255,255,0.35)',
    fontSize: 10,
    fontWeight: '700',
    textAlign: 'center',
  },
  playerRowName: { color: 'rgba(255,255,255,0.88)', fontSize: 13, fontWeight: '600' },
  playerRowSub: { color: 'rgba(255,255,255,0.35)', fontSize: 11, marginTop: 1 },
  playerRowInjuryDetail: { color: 'rgba(251,146,60,0.7)', fontSize: 10, marginTop: 1 },
  // Players
  playerCard: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.07)',
    marginBottom: 6,
    backgroundColor: 'rgba(255,255,255,0.03)',
  },
  playerCardName: { color: '#fff', fontSize: 14, fontWeight: '600' },
  playerCardMarkets: { color: 'rgba(255,255,255,0.35)', fontSize: 11, marginTop: 2 },
  playerPropBtn: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: 'rgba(232,121,249,0.4)',
    backgroundColor: 'rgba(232,121,249,0.08)',
  },
  playerPropBtnText: { color: '#e879f9', fontSize: 11, fontWeight: '600' },
  // Books
  tierHeader: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'flex-start',
    borderLeftWidth: 3,
    paddingLeft: 12,
    marginBottom: 12,
  },
  tierBadge: { paddingVertical: 3, paddingHorizontal: 8, borderRadius: 6, borderWidth: 1 },
  tierBadgeText: { fontSize: 11, fontWeight: '800' },
  tierLabel: { color: '#fff', fontSize: 14, fontWeight: '700', marginBottom: 3 },
  tierDesc: { color: 'rgba(255,255,255,0.45)', fontSize: 12, lineHeight: 18, flex: 1 },
  bookGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 6 },
  bookPill: {
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 6,
    borderWidth: 1,
    backgroundColor: 'rgba(255,255,255,0.03)',
  },
  bookPillText: { fontSize: 12, fontWeight: '600' },
  // Utility
  centered: { flex: 1, justifyContent: 'center', alignItems: 'center', gap: 10 },
  loadingText: { color: 'rgba(255,255,255,0.4)', fontSize: 13 },
  emptyText: { color: 'rgba(255,255,255,0.3)', fontSize: 14, textAlign: 'center', marginTop: 40 },

  // ─── Live Query Anatomy ──────────────────────────────────────────────────────
  anatomyCard: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: 'rgba(167,139,250,0.2)',
    backgroundColor: 'rgba(167,139,250,0.06)',
    padding: 16,
    marginBottom: 24,
  },
  anatomyTitle: { color: '#fff', fontSize: 15, fontWeight: '800', marginBottom: 4 },
  anatomySubtitle: { color: 'rgba(255,255,255,0.45)', fontSize: 12, lineHeight: 18, marginBottom: 12 },
  anatomyInput: {
    backgroundColor: 'rgba(255,255,255,0.07)',
    borderWidth: 1,
    borderColor: 'rgba(167,139,250,0.3)',
    borderRadius: 10,
    paddingHorizontal: 14,
    paddingVertical: 10,
    color: '#fff',
    fontSize: 14,
  },
  anatomyExPill: {
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(167,139,250,0.25)',
    backgroundColor: 'rgba(167,139,250,0.08)',
  },
  anatomyExPillText: { color: '#a78bfa', fontSize: 11 },
  anatomyTokenRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 14,
    marginBottom: 10,
  },
  anatomyToken: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 8,
    borderWidth: 1,
    gap: 2,
  },
  anatomyTokenText: { fontSize: 13, fontWeight: '700' },
  anatomyTokenLabel: { fontSize: 9, fontWeight: '600', textTransform: 'uppercase', letterSpacing: 0.5 },
  anatomyLegend: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    marginTop: 4,
    marginBottom: 10,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.07)',
  },
  anatomyLegendItem: { flexDirection: 'row', alignItems: 'center', gap: 5 },
  anatomyLegendDot: { width: 7, height: 7, borderRadius: 4 },
  anatomyLegendText: { color: 'rgba(255,255,255,0.45)', fontSize: 11 },
  anatomyRunBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#a78bfa',
    borderRadius: 9,
    paddingVertical: 9,
    paddingHorizontal: 18,
    alignSelf: 'flex-start',
  },
  anatomyRunBtnText: { color: '#0f0f17', fontSize: 13, fontWeight: '700' },

  // ─── Examples Gallery ────────────────────────────────────────────────────────
  exGalleryCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.08)',
    backgroundColor: 'rgba(255,255,255,0.03)',
    borderLeftWidth: 3,
    overflow: 'hidden',
    padding: 12,
  },
  exGalleryHeader: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  exGalleryIconWrap: { width: 32, height: 32, borderRadius: 8, justifyContent: 'center', alignItems: 'center' },
  exGalleryLabel: { fontSize: 14, fontWeight: '700' },
  exGalleryDesc: { color: 'rgba(255,255,255,0.4)', fontSize: 11, marginTop: 1 },
  exGalleryRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.06)',
    backgroundColor: 'rgba(255,255,255,0.02)',
  },
  exGalleryQLabel: { color: 'rgba(255,255,255,0.45)', fontSize: 11 },
  exGalleryQQuery: { fontSize: 13, fontWeight: '600', marginTop: 1 },

  // ─── SGP Leg Builder ─────────────────────────────────────────────────────────
  legCard: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(167,139,250,0.2)',
    backgroundColor: 'rgba(167,139,250,0.05)',
    padding: 12,
  },
  legHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 10,
  },
  legBadge: {
    paddingVertical: 2,
    paddingHorizontal: 8,
    borderRadius: 6,
    backgroundColor: 'rgba(167,139,250,0.2)',
    borderWidth: 1,
    borderColor: 'rgba(167,139,250,0.4)',
  },
  legBadgeText: { color: '#a78bfa', fontSize: 11, fontWeight: '700' },
  legSummary: { color: 'rgba(255,255,255,0.5)', fontSize: 12, flex: 1 },
  legRemoveBtn: { marginLeft: 'auto' },
  legFieldLabel: { color: 'rgba(255,255,255,0.35)', fontSize: 10, fontWeight: '700', textTransform: 'uppercase', letterSpacing: 0.7, marginBottom: 5, marginTop: 8 },
  addLegBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginTop: 10,
    paddingVertical: 9,
    borderRadius: 9,
    borderWidth: 1,
    borderColor: 'rgba(167,139,250,0.3)',
    borderStyle: 'dashed',
    justifyContent: 'center',
  },
  addLegBtnText: { color: '#a78bfa', fontSize: 13, fontWeight: '600' },

  // ─── Market Descriptions ─────────────────────────────────────────────────────
  marketDescCard: {
    padding: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(96,165,250,0.2)',
    backgroundColor: 'rgba(96,165,250,0.05)',
  },
  marketDescName: { color: '#60a5fa', fontSize: 13, fontWeight: '700', marginBottom: 3 },
  marketDescText: { color: 'rgba(255,255,255,0.55)', fontSize: 12, lineHeight: 17 },
  marketDescShortcut: { color: 'rgba(96,165,250,0.6)', fontSize: 11, marginTop: 4, fontStyle: 'italic' },

  // ─── Glossary ────────────────────────────────────────────────────────────────
  glossaryCard: {
    padding: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.07)',
    backgroundColor: 'rgba(255,255,255,0.02)',
  },
  glossaryHeader: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
  glossaryTerm: { color: '#fff', fontSize: 14, fontWeight: '700' },
  glossaryPreview: { color: 'rgba(255,255,255,0.35)', fontSize: 12, marginTop: 4, lineHeight: 16 },
  glossaryDef: { color: 'rgba(255,255,255,0.7)', fontSize: 13, lineHeight: 20 },
  glossaryExample: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 7,
    backgroundColor: 'rgba(255,255,255,0.04)',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.07)',
  },
  glossaryExampleText: { fontSize: 12, lineHeight: 17 },
});
